import axiosInstance from "../../../utils/axios";
import { ROLE } from "../../../utils/Constants";
const options = { role: ROLE.SUPER_ADMIN };
const path = "admin/reward-config";

export const rewardConfigList = async (values) => {
  return await axiosInstance(options).post(`${path}/list`, values);
};

export const rewardConfigAdd = async (values) => {
  return await axiosInstance(options).post(`${path}/add`, values);
};

export const rewardConfigEdit = async (values) => {
  return await axiosInstance(options).put(
    `${path}/update/${values.id}`,
    values,
  );
};

export const rewardConfigDetails = async (id) => {
  return await axiosInstance(options).get(`${path}/details/${id}`);
};

export const rewardConfigStatus = async (values) => {
  return await axiosInstance(options).put(`${path}/change-status`, values);
};

export const rewardConfigDelete = async (id) => {
  return await axiosInstance(options).delete(`${path}/delete/${id}`);
};
